export type ReportRange = 'Today' | '7 days' | '30 days';

export const REPORT_RANGES: ReportRange[] = ['Today', '7 days', '30 days'];

export function rangeDays(range: ReportRange): number {
  switch (range) {
    case 'Today':
      return 1;
    case '7 days':
      return 7;
    case '30 days':
      return 30;
  }
}

export function rangeFileSlug(range: ReportRange): string {
  return range.replace(' ', '-').toLowerCase();
}
